import React from "react";
import Login from "../auth/Login";

export default function LoginPage() {
  return <Login />;
}
